import { ColorScheme } from '../types/theme';

export const THEME: ColorScheme = {
    dark: {
        primaryColor: '#EE7674',
        secondaryColor: '#BDD9BF',
        primaryBackgroundColor: '#121212',
        secondaryBackgroundColor: '#000000',
        primaryTextColor: '#E0E0E0',
        secondaryTextColor: '#B0B0B0',
        thinBorderColor: 'rgb(242, 242, 247)',
        sectionBackgroundColor: '#000',
        sectionTextColor: '#FFF',
        sidebarTextColor: '#000',
        sidebarActiveColor: 'rgba(238, 118, 116, 0.6)',
        sidebarHoverColor: 'rgba(189, 217, 191, 0.6)',
        footerBackgroundColor: 'rgb(242, 242, 247)',
        footerTextColor: 'rgb(99, 99, 102)',
        invalidBorderColor: '#ff0000'
    },
    light: {
        primaryColor: '#00BFA6',
        secondaryColor: '#43A047',
        primaryBackgroundColor: '#FAFAFA',
        secondaryBackgroundColor: '#FFFFFF',
        primaryTextColor: '#13584f',
        secondaryTextColor: '#616161',
        thinBorderColor: 'rgb(242, 242, 247)',
        sectionBackgroundColor: '#E0F7F4',
        sectionTextColor: '',
        sidebarTextColor: '',
        sidebarActiveColor: '',
        sidebarHoverColor: '',
        footerBackgroundColor: 'rgb(242, 242, 247)',
        footerTextColor: 'rgb(99, 99, 102)',
        invalidBorderColor: '#E53935'
    }
};
